import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import image from "../../assets/img/Logo_MAE_2024.png";
import logout from "../../assets/img/logout.png";
import email from "../../assets/img/email.png";
import notif from "../../assets/img/notif.png";
import pic from "../../assets/img/pic.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { hasAuthorities } from "../../utils/authoritiesUtils";
import NotificationDropdown from "./NotificationDropdown";
const drawerWidth = 250;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
    background: "rgba(243, 246, 249, 1)",
    fontFamily: "Poppins",
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function Layout({
  children,
  indexRoute,
  setIndexRoute,
  setIdClaim,
  setTaskId,
}) {
  const location = useLocation();
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const userFirstName = localStorage.getItem("userFirstName");
  const userLastName = localStorage.getItem("userLastName");
  const [isDashboardChecked, setIsDashboardChecked] = useState(false);


  useEffect(() => {
    // Check if current path is dashboard
    const isDashboard = location.pathname === '/dashboard';
    setIsDashboardChecked(isDashboard);
    
    const updatedArray = arrayItems.map((item) => ({
      ...item,
      isChecked: !isDashboard && location.pathname.endsWith(item.route),
    }));
    setArrayItems(updatedArray);
  }, [location.pathname]);
  const [arrayItems, setArrayItems] = useState(
    [
      // {
      //   text: "Applications",
      //   route: "/applications",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect x="4" y="4" width="7" height="7" rx="1.5" fill="#4A4B68" />
      //       <path
      //         opacity="0.3"
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M13 5.5C13 4.67157 13.6716 4 14.5 4H18.5C19.3284 4 20 4.67157 20 5.5V9.5C20 10.3284 19.3284 11 18.5 11H14.5C13.6716 11 13 10.3284 13 9.5V5.5ZM4 14.5C4 13.6716 4.67157 13 5.5 13H9.5C10.3284 13 11 13.6716 11 14.5V18.5C11 19.3284 10.3284 20 9.5 20H5.5C4.67157 20 4 19.3284 4 18.5V14.5ZM14.5 13C13.6716 13 13 13.6716 13 14.5V18.5C13 19.3284 13.6716 20 14.5 20H18.5C19.3284 20 20 19.3284 20 18.5V14.5C20 13.6716 19.3284 13 18.5 13H14.5Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect x="4" y="4" width="7" height="7" rx="1.5" fill="#BBC808" />
      //       <path
      //         opacity="0.3"
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M13 5.5C13 4.67157 13.6716 4 14.5 4H18.5C19.3284 4 20 4.67157 20 5.5V9.5C20 10.3284 19.3284 11 18.5 11H14.5C13.6716 11 13 10.3284 13 9.5V5.5ZM4 14.5C4 13.6716 4.67157 13 5.5 13H9.5C10.3284 13 11 13.6716 11 14.5V18.5C11 19.3284 10.3284 20 9.5 20H5.5C4.67157 20 4 19.3284 4 18.5V14.5ZM14.5 13C13.6716 13 13 13.6716 13 14.5V18.5C13 19.3284 13.6716 20 14.5 20H18.5C19.3284 20 20 19.3284 20 18.5V14.5C20 13.6716 19.3284 13 18.5 13H14.5Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   isChecked: true,
      // },
      {
        text: "Experts",
        route: "/experts",
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="4"
              y="4"
              width="8"
              height="16"
              fill="#4A4B68"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
              fill="#4A4B68"
            />
          </svg>
        ),
        iconChecked: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="4"
              y="4"
              width="8"
              height="16"
              fill="#BBC808"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
              fill="#BBC808"
            />
          </svg>
        ),
        requiredAuthority: "VIEW_EXPERTS_LIST",
        isChecked: false,
      },
      // {
      //   text: "Sinistre éligible au réglement",
      //   route: "/SettlementEligibleClaim",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   requiredAuthority: "VIEW_CLAIMS_ELIGIBLE_FOR_PAYMENT_LIST",
      //   isChecked: false,
      // },
      // {
      //   text: "Sinistre à charger sur plateforme",
      //   route: "/ClaimToBeLoadedToPlatform",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   requiredAuthority: "VIEW_LIST_CLAIM_ERECOURS",
      //   isChecked: false,
      // },
      // {
      //   text: "Polices",
      //   route: "/polices",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   isChecked: false,
      // },
      {
        text: "Utilisateurs",
        route: "/users",
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="4"
              y="4"
              width="8"
              height="16"
              fill="#4A4B68"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
              fill="#4A4B68"
            />
          </svg>
        ),
        iconChecked: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="4"
              y="4"
              width="8"
              height="16"
              fill="#BBC808"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
              fill="#BBC808"
            />
          </svg>
        ),
        requiredAuthority: "VIEW_USERS_LIST",
        isChecked: false,
      },
      // {
      //   text: "Propositions de services",
      //   route: "/services",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   requiredAuthority: "VIEW_SERVICE_PROPOSAL_LIST",
      //   isChecked: false,
      // },
      {
        text: "Groupes Utilisateurs",
        route: "/user-groups",
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="4"
              y="4"
              width="8"
              height="16"
              fill="#4A4B68"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
              fill="#4A4B68"
            />
          </svg>
        ),
        iconChecked: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="4"
              y="4"
              width="8"
              height="16"
              fill="#BBC808"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
              fill="#BBC808"
            />
          </svg>
        ),
        requiredAuthority: "VIEW_USER_GROUPS_LIST",
        isChecked: false,
      },
      {
        text: "Référentiel Agences",
        route: "/agencies-reference",
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="4"
              y="4"
              width="8"
              height="16"
              fill="#4A4B68"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
              fill="#4A4B68"
            />
          </svg>
        ),
        iconChecked: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="4"
              y="4"
              width="8"
              height="16"
              fill="#BBC808"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
              fill="#BBC808"
            />
          </svg>
        ),
        requiredAuthority: "VIEW_AGENCY_LIST",
        isChecked: false,
      },
      // {
      //   text: "Réparateur",
      //   route: "/repairers",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   requiredAuthority: "VIEW_REPAIRER_LIST",
      //   isChecked: false,
      // },
      {
        text: "Sinistres",
        route: "/sinistres",
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="4"
              y="4"
              width="8"
              height="16"
              fill="#4A4B68"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
              fill="#4A4B68"
            />
          </svg>
        ),
        iconChecked: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.3"
              x="4"
              y="4"
              width="8"
              height="16"
              fill="#BBC808"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
              fill="#BBC808"
            />
          </svg>
        ),
        requiredAuthority: "VIEW_CLAIM_LIST",
        isChecked: false,
      },
      // {
      //   text: "Tâches à faire",
      //   route: "/todo-list",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   requiredAuthority: "VIEW_TO_DO_LIST",
      //   isChecked: false,
      // },
      
      // {
      //   text: "Réglements",
      //   route: "/payment",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   isChecked: false,
      //   requiredAuthority: "VIEW_PAYMENT_LIST",
      // },
      // {
      //   text: "Planning",
      //   route: "/planning",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   isChecked: false,
      //   requiredAuthority: "VIEW_SCHEDULE_LIST",
      // },
      // {
      //   text: "Voiture de remplacement",
      //   route: "/voiture_de_remplacement",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   isChecked: false,
      //   requiredAuthority: "VIEW_VR_LIST",
      // },
      // {
      //   text: "Expertises",
      //   route: "/expertises",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   isChecked: false,
      //   requiredAuthority: "VIEW_INSPECTIONS_LIST",
      // },
      // {
      //   text: "Missions de réparation",
      //   route: "/reparation_mission_list",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   isChecked: false,
      //   requiredAuthority: "VIEW_REPAIR_MISSIONS_LIST",
      // },
      // {
      //   text: "Investigations",
      //   route: "/investigations",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   isChecked: false,
      //   requiredAuthority: "VIEW_INVESTIGATIONS_LIST",
      // },
      // {
      //   text: "Planning Inspecteurs",
      //   route: "/inspector-shifts",
      //   icon: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#4A4B68"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#4A4B68"
      //       />
      //     </svg>
      //   ),
      //   iconChecked: (
      //     <svg
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <rect
      //         opacity="0.3"
      //         x="4"
      //         y="4"
      //         width="8"
      //         height="16"
      //         fill="#BBC808"
      //       />
      //       <path
      //         fillRule="evenodd"
      //         clipRule="evenodd"
      //         d="M18 6H15C15 6 14 5.82843 14 5C14 4.17157 15 4 15 4H20V9C20 9 20 10 19 10C18 10 18 9 18 9V6ZM9 18H6V15C6 15 6 14 5 14C4 14 4 15 4 15V20H9C9 20 10 19.8284 10 19C10 18.1716 9 18 9 18ZM18 15V18H15C15 18 14 18 14 19C14 20 15 20 15 20H20V15C20 15 19.8284 14 19 14C18.1716 14 18 15 18 15ZM6 9V6H9C9 6 10 6 10 5C10 4 9 4 9 4H4V9C4 9 4.17157 10 5 10C5.82843 10 6 9 6 9Z"
      //         fill="#BBC808"
      //       />
      //     </svg>
      //   ),
      //   isChecked: false,
      //   requiredAuthority: "VIEW_INSPECTOR_SHIFTS_LIST",
      // },
    ].filter(
      (item) =>
        !item.requiredAuthority || hasAuthorities(item.requiredAuthority)
    )
  );

  const handleDashboardClick = () => {
    // Update dashboard checked state
    setIsDashboardChecked(true);
    
    // Reset all other items' checked state
    const array = arrayItems.map((item) => {
      return { ...item, isChecked: false };
    });
    setArrayItems(array);
    
    // Navigate to dashboard
    navigate("/dashboard");
  };

  const handleItemClick = (index) => {
    // Reset dashboard checked state
    setIsDashboardChecked(false);
    
    const array = arrayItems.map((item, idx) => {
      if (idx === index) {
        return { ...item, isChecked: true };
      } else {
        return { ...item, isChecked: false };
      }
    });
    setArrayItems(array);
    setIndexRoute(arrayItems[index].text);
    navigate(arrayItems[index].route);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const ProfileContainer = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    padding: "50px 0",
    borderTopLeftRadius: "50px",
    borderTopRightRadius: "50px",
    position: "relative", // This will allow the icon to be positioned relatively to this container
  });

  const ProfilePic = styled("img")({
    borderRadius: "50%",
    border: "3px solid rgba(187, 200, 8, 0.5)",
    padding: "2px",
    width: "10rem",
    height: "10rem",
    marginBottom: "10px",
    position: "relative",
  });

  const EditIcon = styled("div")({
    position: "absolute",
    top: "15%",
    right: "15%",
    width: "23px",
    height: "23px",
    cursor: "pointer",
    "& svg": {
      width: "100%",
      height: "100%",
    },
  });
  const ProfileName = styled("div")({
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 500,
    color: "rgba(136, 140, 159, 1)",
  });
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        style={{
          background: "rgba(60, 101, 86, 1)",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
          zIndex: 1300,
        }}
        open={open}
      >
        <Toolbar>
          {!open ? (
            <IconButton
              disableRipple
              disableFocusRipple
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                mr: 2,
                ...(open && { display: "none" }),
                color: "rgba(187, 200, 8, 1)",
                height: "64px",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            ""
          )}
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              margin: "20px",
              position: "absolute",
              left: "40px",
            }}
          >
            <div
              style={{
                color: "rgba(255, 255, 255, 1)",
                display: "block",
                fontFamily: "Poppins",
                fontSize: 13,
                fontWeight: 500,
                lineHeight: "16.5px",
                marginRight: "10px",
              }}
            >
              Bonjour ,
              <span
                style={{
                  color: "rgba(255, 255, 255, 1)",
                  fontFamily: "Poppins",
                  fontSize: 13,
                  fontWeight: 500,
                  lineHeight: "19.5px",
                }}
              >
                &nbsp;{userFirstName}&nbsp;{userLastName}{" "}
              </span>
            </div>
          </Box>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              position: "absolute",
              right: "0px",
            }}
          >
            <div
              style={{
                color: "rgba(255, 255, 255, 1)",
                display: "block",
                fontFamily: "Poppins",
                fontSize: 11,
                fontWeight: 500,
                lineHeight: "16.5px",
                marginRight: "10px",
              }}
            >
      <NotificationDropdown notifIcon={notif} emailIcon={email} logoutIcon={logout} />
            </div>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "rgba(243, 246, 249, 1)",

            border: 0,
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader style={{ background: "rgba(60, 101, 86, 1)" }}>
          <img style={{ width: "68px", height: "62px", marginRight: "2rem" }} src={image} alt="" />
          <IconButton
            onClick={handleDrawerClose}
            disableRipple
            disableFocusRipple
            sx={{
              marginLeft: "10px",
              height: "64px",
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <ChevronLeftIcon style={{ color: "rgba(255, 255, 255, 1)" }} />
            <ChevronLeftIcon
              style={{ marginLeft: "-15px", color: "rgba(255, 255, 255, 0.3)" }}
            />
          </IconButton>
        </DrawerHeader>

        <Box
          sx={{
            marginLeft: "10px",
            backgroundColor: "white",
            marginTop: "24px",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
            height: "100%",
            overflow: "auto",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            "-ms-overflow-style": "none",
          }}
        >
          <ProfileContainer>
            <ProfilePic src={pic} alt="Profile Picture" />
            {/* <AiOutlineUser style={{   
    borderRadius: "50%",
    border: "3px solid rgba(187, 200, 8, 0.5)",
    padding: "5px",
    width: "9rem",
    height: "9rem",
    marginBottom: "10px",
    position: "relative", }}   /> */}
            <ProfileName>
              {userFirstName}&nbsp;{userLastName}
            </ProfileName>
            <EditIcon>
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none">
                <ellipse
                  cx="11.359"
                  cy="11.0977"
                  rx="11.0977"
                  ry="11.0977"
                  fill="#BBC808"
                />
                <rect
                  x="6.05096"
                  y="4.82526"
                  width="11.5802"
                  height="11.5802"
                  fill="url(#pattern0)"
                />
                <defs>
                  <pattern
                    id="pattern0"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                  >
                    <use xlinkHref="#image0" transform="scale(0.0078125)" />
                  </pattern>
                  <image
                    id="image0"
                    width="128"
                    height="128"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAABfxJREFUeJztncurVWUcht/PGypaBnnJHOQgtCAHSRkmOAqMhIImQWEF9QdUgwYNim6TQIkobRBFEUSgDSISa2JZ5Dml5CAQwzuox5STBd7Ip8Ha4uZ4jmuvb9322d/7wEYO2/X93vU9v7PXXuvbZy/JGGOMMcYYY4wxxhhjjDGDTGg7QCoA90haK2mlpDsl3SZprjIH5ySdknRA0h5JOyX9HkKgnbSmEoCFwKvAAYpzCHgTWNz2fpiCALcA7wLnI8SP5QKwGbi17f0yPQA8DoxUIH4sZ4Cn2t4/MwHAVODTGsSP5SNgRtv7a7oA5gFHGpB/lR3AnCqy+yygJMBMSX9Kur3h0t9JWh9CuFRmkCkVhUmSjvwdal6+JD0kaUvZQfwKEElH/leS1hXY7LSkbyRtl3RQ0glJSFokaWlnrEc6P/fKhhDCZwX+vykLMBP4tsAx+zTwcqdp8saeDmwguw7QC2eB+U3st1GU/GFgXkSdOcC2HmuUPhSYHoiQPwRMLVEvAO/0UOcisKTKfTVjAGYAXxeQv7WiugHY2kO9t6uoZ8YhQv6miuvPAY7m1DwC+E191bQtvyvHcz3UXllH7WTpF/mdLNOA4zn1X6yrfnKQregd6gf5XZm25GT4vO4MSQDMJlt96xv5nVyP5eQYaiLHQEP2sr+n3+R3sq3IyXKsqSwDCX10zJ8g3/ycPKNFx/RiUAeyNfatktYX2aymOKZJIn7zu9nYYE4fAqqmpPxGmwC/CayWiuQ31gT4NLA6KpZfexPgC0HVESH/cNtNADzfQ+1766g9UETI30S2DLy9rSYgWww6llPzMF4MujEx8ru2baUJyJaDd/ZQz8vBN6KM/K4xijZB6QtFwPc91LkAtPHB1MlBFfK7xmqsCYAPe6zxQWyNgadK+V1j1t4EwGs9jn0G/93g+NQhv2vs2pqggHyAJ+NmZ8CpU35XjcqboKD8Sj53OHA0Ib+rVmVNUFD+SWB6bO6BhRaWdKmgCSgmfwRYUDb3wEGL6/mUaAKKyR8G5laVe2CgDz7MEZOBYvJ3YfnXEzPxfZTF8svQT/JLZLL8GPpRfle2on9HaPlF6Gf5XRnLNoHlj8dkkN+VNbYJLH88JpP8MZn3W35JJqN8qfB5vuWPRyLyj1r+OCQi/yy+vHs9icj/A7ip7cx9RyLyfcwfD8tPGMtPGMtPGMtPGMtPGMtPGMtPGMtPGMtPGMtPGMtPGMtPGMtPGMtPGMtPGMtPGLI7bewbcPk/UtGduwcKsluenrT8RAE+sfyEIbtBsuWnCDAFuGz5iQLc1cNEvtd2Tsnv9msBeCZnIk+1nVGy/NoANudMZutfZmz5NUL+jRafbjmf5dcFMAu4lDOpy1vMZ/l1AqzJmdRRoJUbVFp+AwAv5UzsjpZyWX4TAF/mTO4bLWSy/KYAjuRMcJF78VaRx/KbAljQwyQvbDCP5TcJ8GjOJB9qMIvlNw3wVs5Ef9FQDstvA/LvafdCAxksvw3IVgBHcyZ8dc0ZLL8tgLtzJvwSMKvG+pbfJsCzOZP+a421Lb9tgC05E/9+TXUtvx8A9uZM/oYaar5u+X0A2ce/8z4CtqyCOkuBJ4CNZN+kbfkVMy1yu5U5245KOlBkQOBmSfdLWtX1b8y3Z/8k6eEQwj8R2yZHbAOsynl+KIRwZaIngWmSlilrpAclrZG0XFLZZWPLL0hsA9yX8/xQ9w/AYmWyrwpfLWl2ZO2J2KVM/r8VjzvQ1PUKcBF4RddeyuteELL8SELRDYBFkk7UkCWWQ5JWWH4cMcfcvN/+Jjkn6QHLjyemAdZVnqIYV5SdZWyTtCSEMNJynklNzCHghKRFNWSZiIPK3t3/1nkMhxAuNlh/oIlpgP9U/nRtIv6WNKxrwn8OIZypqZZR/FlAFZyXtFfSbmWnjb+EEA63mCdJYhrgqKQ7Cm6DpP3KRO/uPPaFEC5H1DcVEnMIWCPph5xtR3RN9pCyK4OjUQlN/wGsBY4DVzqPv4CPOws3S9vOZ4wxxhhjjDHGGGOMMcYYzL+B0h1iQ5AIubNAAAAAElFTkSuQmCC"
                  />
                </defs>
              </svg>
            </EditIcon>
          </ProfileContainer>

          {hasAuthorities("VIEW_DASHBOARD") && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              margin: "0px 20px 20px 20px",
              height: "44px",
              backgroundColor: isDashboardChecked
                ? "rgba(243, 246, 249, 1)"
                : "rgba(255, 255, 255, 1)",
              padding: "0 10px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => handleDashboardClick()}
          >
             <div style={{ marginLeft: "20px" }}>
               {isDashboardChecked ? (
                 <svg
                   width="25"
                   height="25"
                   viewBox="0 0 25 25"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <path
                     d="M11.4688 16.7646C12.0172 17.2038 12.797 17.2035 13.3451 16.764L20.0169 11.4128L20.246 11.2301C20.9977 10.6304 20.9989 9.48824 20.2485 8.88695L13.3451 3.35555C12.797 2.91632 12.0174 2.91632 11.4692 3.35555L4.56144 8.89053C3.81245 9.49068 3.81196 10.6301 4.56044 11.2309L4.78712 11.4128L11.4688 16.7646Z"
                     fill="#BBC808"
                   />
                   <path
                     opacity="0.3"
                     fillRule="evenodd"
                     clipRule="evenodd"
                     d="M13.3347 19.4702C12.7866 19.9094 12.0072 19.9094 11.459 19.4704L5.52621 14.7185C5.11478 14.389 4.51294 14.4616 4.19168 14.8795C3.87519 15.2913 3.95204 15.8815 4.36341 16.1985L11.4902 21.6902C12.0297 22.106 12.7815 22.106 13.3211 21.6904L20.4445 16.2034C20.8594 15.8838 20.9367 15.2885 20.6172 14.8736C20.2932 14.4529 19.6872 14.3802 19.2729 14.7121L13.3347 19.4702Z"
                     fill="#BBC808"
                   />
                 </svg>
               ) : (
                 <svg
                   width="25"
                   height="25"
                   viewBox="0 0 25 25"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <path
                     d="M11.4688 16.7646C12.0172 17.2038 12.797 17.2035 13.3451 16.764L20.0169 11.4128L20.246 11.2301C20.9977 10.6304 20.9989 9.48824 20.2485 8.88695L13.3451 3.35555C12.797 2.91632 12.0174 2.91632 11.4692 3.35555L4.56144 8.89053C3.81245 9.49068 3.81196 10.6301 4.56044 11.2309L4.78712 11.4128L11.4688 16.7646Z"
                     fill="#4A4B68"
                   />
                   <path
                     opacity="0.3"
                     fillRule="evenodd"
                     clipRule="evenodd"
                     d="M13.3347 19.4702C12.7866 19.9094 12.0072 19.9094 11.459 19.4704L5.52621 14.7185C5.11478 14.389 4.51294 14.4616 4.19168 14.8795C3.87519 15.2913 3.95204 15.8815 4.36341 16.1985L11.4902 21.6902C12.0297 22.106 12.7815 22.106 13.3211 21.6904L20.4445 16.2034C20.8594 15.8838 20.9367 15.2885 20.6172 14.8736C20.2932 14.4529 19.6872 14.3802 19.2729 14.7121L13.3347 19.4702Z"
                     fill="#4A4B68"
                   />
                 </svg>
               )}
             </div>
            <Box
              sx={{
                fontFamily: "Poppins",
                fontSize: 12,
                fontWeight: 400,
                lineHeight: "18px",
                flex: 2,
                marginLeft: "10px",
                color: isDashboardChecked
                  ? "rgba(187, 200, 8, 1)"
                  : "rgba(136, 140, 159, 1)",
              }}
            >
              Dashboard
            </Box>
            <Box sx={{ marginRight: "20px" }}>
              <ChevronRightIcon
                sx={{ color: "rgba(73, 75, 105, 1)", fontSize: 16 }}
              />
            </Box>
          </Box>
          )}
          <Box
            style={{
              fontFamily: "Poppins",
              fontSize: 12,
              fontWeight: 400,
              lineHeight: "18px",
              color: "rgba(74, 75, 104, 1)",
              margin: "20px 20px 20px 20px",
              backgroundColor: isDashboardChecked ? "rgba(243, 246, 249, 1)" : "rgba(255, 255, 255, 1)",
            }}
          ></Box>

          {arrayItems.map((item, index) => (
            <Box
              key={index}
              sx={{
                height: "44px",
                display: "flex",
                alignItems: "center",
                backgroundColor: item.isChecked
                  ? "rgba(243, 246, 249, 1)"
                  : "rgba(255, 255, 255, 1)",
                cursor: "pointer",
              }}
              onClick={() => handleItemClick(index)}
            >
              <div style={{ marginLeft: "20px" }}>
                {item.isChecked ? <>{item.iconChecked}</> : <>{item.icon}</>}
              </div>
              <Box
                sx={{
                  fontFamily: "Poppins",
                  fontSize: 12,
                  fontWeight: 400,
                  lineHeight: "18px",
                  flex: 2,
                  marginLeft: "10px",
                  color: item.isChecked
                    ? "rgba(187, 200, 8, 1)"
                    : "rgba(136, 140, 159, 1)",
                }}
              >
                {item.text}
              </Box>
              <Box sx={{ marginRight: "20px" }}>
                <ChevronRightIcon
                  sx={{ color: "rgba(73, 75, 105, 1)", fontSize: 16 }}
                />
              </Box>
            </Box>
          ))}
        </Box>
      </Drawer>

      <Main open={open}>
        <DrawerHeader />
        <Box>{children}</Box>
      </Main>
    </Box>
  );
}
